import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';

import { getAuthHint } from '../requests';
import type { GetAuthHintRequestType } from '../types';

export const useGetAuthHint = (
  { pathParams: { hintToken } }: GetAuthHintRequestType,
  options?: {
    enabled?: boolean;
  },
) =>
  useQuery({
    queryKey: [API_QUERY_KEYS.authHint, { hintToken }],
    queryFn: () => getAuthHint({ pathParams: { hintToken } }),
    ...options,
  });
